// extracted by mini-css-extract-plugin
export default {"root":"TabNav_root__2jlLZ","tab":"TabNav_tab__Jd3Ya","link":"TabNav_link__331cQ","selectedLink":"TabNav_selectedLink__1CsmK","disabled":"TabNav_disabled__3hSHC"};